export const version = '2.10.6'
